import { render, staticRenderFns } from "./DetailSettingTax.vue?vue&type=template&id=627277a6"
import script from "./DetailSettingTax.vue?vue&type=script&lang=js"
export * from "./DetailSettingTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports